/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import { Link, useRouteMatch } from "react-router-dom";

import AudiencePortrait from "./AudiencePortrait";
import WordCloudPanel from "./WordCloudPanel";
import { Button } from "../../../../components/simple";
import SVG from "../../../../components/SVG";
import * as routes from "../../../../router/routes";

import styles from "./audience-description.module.scss";
import LoadingIndicator from "../../../../components/simple/LoadingIndicator/LoadingIndicator";

const AudienceDescription = props => {
  const {
    audience,
    handleMapModal,
    words,
    personaDescription,
    nothingToShow,
    isLoading,
    isLoadingTags,
    isLoadingMapData
  } = props;
  const match = useRouteMatch(
    `${routes.audiencesCreateWithoutTemplate("")}/:id`
  );

  const handleLinkClick = e => {
    if (!audience?.audienceVariables?.length) e.preventDefault();
  };

  return (
    <>
      <div className={styles["persona-description-wrapper"]}>
        <div className={styles["audience-description-info"]}>
          <h3>Pre-campaign report</h3>
          <p>
            This is a sneak peak to learn more about the underlying
            characteristics of your audience.&nbsp;
            <Link
              to={{
                pathname: `${routes.fullReport}/${match.params.id}/${audience.threshold}/audience`,
                state: { audience }
              }}
              onClick={handleLinkClick}
            >
              See full pre-campaign report
            </Link>
          </p>

          <div className={styles["audience-description-relative"]}>
            <Button
              onClick={handleMapModal}
              className={styles["audience-description-button"]}
              disabled={isLoadingMapData}
            >
              <SVG.Map width={24} height={24} />
              <span>See where they live</span>
            </Button>
            {isLoadingMapData && (
              <div className={styles["audience-description-loader-container"]}>
                <LoadingIndicator variant="dark" />
              </div>
            )}
          </div>
        </div>

        <div className={styles["audience-description-title"]}>Who they are</div>
        <div
          className={`${styles["audience-description-portraits-list"]} ${
            isLoading ? styles["is-loading"] : ""
          }`}
        >
          {!nothingToShow ? (
            personaDescription.map(persona => (
              <AudiencePortrait audience={persona} key={persona.imageLink} />
            ))
          ) : (
            <p>No data to display</p>
          )}
        </div>
      </div>
      {!nothingToShow ? (
        <div className={styles["wordcloud-wrapper"]}>
          <WordCloudPanel words={words} isLoading={isLoadingTags} />
        </div>
      ) : (
        <div>
          <div className={styles["audience-description-title"]}>
            Description
          </div>
          <p>No data to display</p>
        </div>
      )}
    </>
  );
};

AudienceDescription.propTypes = {
  audience: PropTypes.shape({
    threshold: PropTypes.number,
    audienceVariables: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  // selectedVariables: PropTypes.arrayOf(PropTypes.shape({})),
  handleMapModal: PropTypes.func.isRequired,
  words: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  personaDescription: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  nothingToShow: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingTags: PropTypes.bool,
  isLoadingMapData: PropTypes.bool.isRequired
};

AudienceDescription.defaultProps = {
  nothingToShow: false,
  isLoading: false,
  isLoadingTags: false
};

export default AudienceDescription;
